import { render, staticRenderFns } from "./ChildMessageList.vue?vue&type=template&id=7f533191"
import script from "./ChildMessageList.vue?vue&type=script&lang=js"
export * from "./ChildMessageList.vue?vue&type=script&lang=js"
import style0 from "./ChildMessageList.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports